export const TEMP_FLAG_URL =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/1200px-Flag_of_Canada_%28Pantone%29.svg.png'

export const ANNUAL_SALARY = 'ANNUAL_SALARY'
export const MONTHLY_SALARY = 'MONTHLY_SALARY'
export const WEEKLY_SALARY = 'WEEKLY_SALARY'
export const DAY_SALARY = 'DAY_SALARY'
export const HOUR_SALARY = 'HOUR_SALARY'
